export default {
  injuryImpact: {
    title: "Lesões",
    labels: {
      withoutPlayer: "Sem {{player}}",
    },
    empty: {
      title: "Nenhuma lesão disponível",
    },
  },
};
